import * as R from 'ramda';
import { connect } from 'react-redux';
import { compose, withHandlers, withState } from 'recompose';

import { sortDataByCreatedAt } from '../../utils';
import { openModal, modalNames } from '../../modals';
import CommentsList from '../../components/comments-list';
import { getCommentsWithCreator } from '../../redux/selectors';
import { handleCommentCreate, handleCommentDelete } from '../../redux/thunk/comments';


const mapStateToProps = (state, props) => ({
  comments: R.compose(sortDataByCreatedAt, getCommentsWithCreator)(state, props),
});

export default compose(
  connect(mapStateToProps, {
    openModal,
    handleCommentCreate,
    handleCommentDelete,
  }),
  withState('data', 'setData', { innerHTML: '', innerText: '' }),
  withHandlers({
    handleCommentDelete: props => (commentId) => {
      props.handleCommentDelete(commentId, props.comments.length);
    },
    openCommentModal: ({ requestId, companyId, ...actions }) => (commentId) => {
      actions.openModal({
        name: modalNames.COMMENTS,
        payload: { requestId, companyId, commentId },
      });
    },
    onTextChange: ({ setData }) => (content, delta, source, editor) => {
      setData({
        innerHTML: content,
        innerText: editor.getText(content),
      });
    },
    onSave: ({
      data, setData, requestId, companyId, ...actions
    }) => (event) => {
      event.preventDefault();

      actions.handleCommentCreate({
        requestId,
        companyId,
        text: data.innerHTML,
      });

      setData({
        innerHTML: '',
        innerText: '',
      });
    },
  }),
)(CommentsList);



// WEBPACK FOOTER //
// ./src/containers/comments-list/index.js